import { memo } from 'react';
import { SecretField } from '@qrios/frontend-library';
import { useTheme } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import { FileCopy } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Tooltip from '../tooltip';

interface Props {
  popup: {
    setStateCallback(state: boolean): void;
    setMsgCallback(msg: string): void;
  };
  value: string;
  label: string;
}

const InfoField = ({ popup, value, label }: Props) => {
  const theme = useTheme();

  const handleClipboard = () => {
    popup.setStateCallback(true);
    popup.setMsgCallback(`${label} copied to clipboard`);
  };
  return (
    <Box display="flex" alignItems="center">
      <SecretField
        name={label}
        value={value}
        handleChange={() => null}
        handleBlur={() => null}
        label={label}
        disabled
      />
      <Tooltip title="Copy to clipboard">
        <Box height={theme.customComponents.form.size.large} marginBottom="-5px" ml={1}>
          <CopyToClipboard text={value}>
            <IconButton aria-label="copy to clipboard" onClick={handleClipboard} size="large" data-testid="button-copy">
              <FileCopy />
            </IconButton>
          </CopyToClipboard>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default memo(InfoField);
